<script setup lang="ts">
import useLocale from '../../composables/useLocale';
import { useDisplay } from 'vuetify';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faGear as faGearSolid } from '@fortawesome/pro-solid-svg-icons';
import { faGear } from '@fortawesome/pro-regular-svg-icons';
import { storeToRefs } from 'pinia';
import useReaderStore from '../../stores/reader';
import { computed } from 'vue';

library.add(faGear, faGearSolid);

type Emits = {
  (e: 'reset'): void;
  (e: 'close'): void;
};
const emit = defineEmits<Emits>();

const { smAndDown } = useDisplay();
const { t } = useLocale();
const { isAudioOnly } = storeToRefs(useReaderStore());

const icon = computed(() => (isAudioOnly.value ? 'fa-regular fa-gear' : 'fa-solid fa-gear'));
</script>

<template>
  <v-card
    data-testid="bp-settings-card"
    class="mx-auto"
    :class="{ 'width-screen-100': smAndDown, 'accent-card': isAudioOnly }"
    min-width="320"
    :color="isAudioOnly ? 'surface' : 'inverse-surface'"
  >
    <v-card-title class="d-flex align-center">
      <FontAwesomeIcon class="mr-2" :class="{ 'pl-2': isAudioOnly }" :icon="icon" />
      <span>{{ t('label_settings') }}</span>
      <v-spacer />
      <v-btn
        v-if="smAndDown"
        icon="mdi-close"
        variant="text"
        @click="emit('close')"
        :color="isAudioOnly ? 'on-surface' : 'primary'"
      >
      </v-btn>
    </v-card-title>
    <v-card-text :class="{ 'pa-0 width-screen-100': smAndDown }">
      <v-list bg-color="transparent" density="compact">
        <slot />
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn class="text-none" variant="text" color="on-surface" @click="emit('reset')">{{ t('button_reset') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped lang="scss">
.v-card {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.width-screen-100 {
  width: 100vw !important;
}

.accent-card {
  border-left: 10px solid rgb(var(--v-theme-brand-original)) !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
